import { ChangeDetectorRef, ElementRef, EventEmitter, } from '@angular/core';
import { DropdownHelperService } from 'Angular/services/dropdown-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/dropdown-helper.service";
import * as i2 from "../../../directives/append-to-body/append-to-body.directive";
import * as i3 from "@angular/common";
import * as i4 from "../../../directives/disabled/disabled.directive";
import * as i5 from "../../modals/help-modal/components/help-modal.component";
import * as i6 from "../../../directives/icon/icon.directive";
import * as i7 from "../../../directives/popovers/tooltip/tooltip.directive";
const _c0 = ["dropdownMenu"];
const _c1 = a0 => ({ show: a0 });
const _c2 = a0 => ({ "dropdown-toggle": a0 });
const _c3 = a0 => ({ "dropdown-item-text-with-new": a0 });
function SimpleDropdownComponent_a_1__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.config.title.iconClass);
    i0.ɵɵproperty("name", ctx_r1.config.title.icon);
} }
function SimpleDropdownComponent_a_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r1.config.title.icon ? "\u00A0" + ctx_r1.config.title.label : ctx_r1.config.title.label);
} }
function SimpleDropdownComponent_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵlistener("click", function SimpleDropdownComponent_a_1_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleOpen()); });
    i0.ɵɵtemplate(1, SimpleDropdownComponent_a_1__svg_svg_1_Template, 1, 3, "svg", 7)(2, SimpleDropdownComponent_a_1_span_2_Template, 1, 1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.buttonClass);
    i0.ɵɵproperty("tooltipTitle", ctx_r1.tooltipText)("ngClass", i0.ɵɵpureFunction1(7, _c2, ctx_r1.showDropdownCaret))("disabled", ctx_r1.inputDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.title.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.title.label);
} }
function SimpleDropdownComponent_a_2__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.config.title.iconClass);
    i0.ɵɵproperty("name", ctx_r1.config.title.icon);
} }
function SimpleDropdownComponent_a_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r1.config.title.icon ? "\u00A0" + ctx_r1.config.title.label : ctx_r1.config.title.label);
} }
function SimpleDropdownComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 11);
    i0.ɵɵlistener("click", function SimpleDropdownComponent_a_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleOpen()); });
    i0.ɵɵtemplate(1, SimpleDropdownComponent_a_2__svg_svg_1_Template, 1, 3, "svg", 7)(2, SimpleDropdownComponent_a_2_span_2_Template, 1, 1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.buttonClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2, ctx_r1.showDropdownCaret))("disabled", ctx_r1.inputDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.title.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.title.label);
} }
function SimpleDropdownComponent_span_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
} }
function SimpleDropdownComponent_span_5_a_2__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 9);
} if (rf & 2) {
    const listItem_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("name", listItem_r5.icon);
} }
function SimpleDropdownComponent_span_5_a_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 21);
    i0.ɵɵlistener("click", function SimpleDropdownComponent_span_5_a_2_ng_container_4_Template_span_click_3_listener($event) { i0.ɵɵrestoreView(_r6); const listItem_r5 = i0.ɵɵnextContext(2).$implicit; i0.ɵɵnextContext(); const helpModal_r7 = i0.ɵɵreference(7); helpModal_r7.openModal(listItem_r5.helpName); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵtext(4, "(?)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function SimpleDropdownComponent_span_5_a_2__svg_svg_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 9);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-new");
} }
function SimpleDropdownComponent_span_5_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 16);
    i0.ɵɵlistener("click", function SimpleDropdownComponent_span_5_a_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r4); const listItem_r5 = i0.ɵɵnextContext().$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.submit(listItem_r5)); });
    i0.ɵɵtemplate(1, SimpleDropdownComponent_span_5_a_2__svg_svg_1_Template, 1, 1, "svg", 17);
    i0.ɵɵelementStart(2, "span", 18);
    i0.ɵɵelement(3, "span", 19);
    i0.ɵɵtemplate(4, SimpleDropdownComponent_span_5_a_2_ng_container_4_Template, 5, 0, "ng-container", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SimpleDropdownComponent_span_5_a_2__svg_svg_5_Template, 1, 1, "svg", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("dropdown-item ", listItem_r5.dropdownItemClass));
    i0.ɵɵproperty("disabled", listItem_r5.disabled);
    i0.ɵɵattribute("data-test-id", "dropdown-option-" + listItem_r5.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!listItem_r5.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c3, ctx_r1.config.hasNew))("textContent", listItem_r5.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", listItem_r5.helpName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!listItem_r5.isNew);
} }
function SimpleDropdownComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtemplate(1, SimpleDropdownComponent_span_5_div_1_Template, 1, 0, "div", 13)(2, SimpleDropdownComponent_span_5_a_2_Template, 6, 12, "a", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r5 = ctx.$implicit;
    i0.ɵɵproperty("ngSwitch", listItem_r5.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "divider");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "option");
} }
/**
 *
 * Simple Dropdown Component
 *
 * This component is responsible for displaying a scrollable list of items which may be visually grouped. Clicking an
 * item selects it and closes the drop down.
 *
 *
 *  * Input Properties
 *   buttonClass: The CSS class to be applied to the button that opens the dropdown
 *   config: The config object, specifying how the dropdown title and items should be configured.
 *   dropdownClass: The CSS class to be applied to the dropdown menu itself
 *   externalToggle: HTMLElement that is external to this component to be used as the dropdown toggle.
 *   inputDisabled: Whether the dropdown should be disabled
 *   showDropdownCaret: Whether the dropdown caret/arrow should be visible. Set this to false when you want to use a different icon as the dropdown toggle.
 *   closeOnSubmit: Whether to close the dropdown automatically when an option is selected
 *   tooltipText: a small descriptive message or text label that is displayed when users hover their
 *   mouse over view.
 *
 *
 *  Output properties
 *    handler: EventEmitter that emits the item's value whenever a new item is selected
 *
 */
export class SimpleDropdownComponent {
    get isOpen() {
        return this._isOpen;
    }
    set isOpen(value) {
        this._isOpen = value;
        this.isOpenChange.emit(value);
    }
    constructor(el, dropdownHelperService, cd) {
        this.el = el;
        this.dropdownHelperService = dropdownHelperService;
        this.cd = cd;
        this.appendToBody = false;
        this.inputDisabled = false;
        this.showDropdownCaret = true;
        this.closeOnSubmit = true;
        this.handler = new EventEmitter();
        this.isOpenChange = new EventEmitter(false);
        this._isOpen = false;
    }
    ngAfterViewInit() {
        const autoCloseHandler = () => {
            if (this.isOpen) {
                this.isOpen = false;
            }
            this.cd.detectChanges();
        };
        if (this.appendToBody) {
            this.dropdownHelperService.setCloseHandler(this.dropdownMenu.nativeElement, autoCloseHandler);
        }
        else {
            this.dropdownHelperService.setCloseHandler(this.externalToggle ?? this.el.nativeElement, autoCloseHandler);
        }
    }
    toggleOpen() {
        if ((!this.inputDisabled || this.isOpen) && !this.externalToggle) {
            this.isOpen = !this.isOpen;
        }
    }
    submit(listItem) {
        if (!listItem.disabled && listItem.value) {
            this.handler.emit(listItem.value);
        }
        if (this.closeOnSubmit) {
            this.isOpen = false;
        }
    }
}
SimpleDropdownComponent.ɵfac = function SimpleDropdownComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SimpleDropdownComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.DropdownHelperService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
SimpleDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SimpleDropdownComponent, selectors: [["ycn-simple-dropdown"]], viewQuery: function SimpleDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownMenu = _t.first);
    } }, inputs: { appendToBody: "appendToBody", buttonClass: "buttonClass", config: "config", dropdownClass: "dropdownClass", inputDisabled: "inputDisabled", showDropdownCaret: "showDropdownCaret", closeOnSubmit: "closeOnSubmit", tooltipText: "tooltipText", externalToggle: "externalToggle" }, outputs: { handler: "handler", isOpenChange: "isOpenChange" }, standalone: false, decls: 8, vars: 10, consts: [["dropdownMenu", ""], ["helpModal", ""], ["ycnTooltip", "", "href", "javascript:void(0)", "ycnDisabled", "", 3, "class", "tooltipTitle", "ngClass", "disabled", "click", 4, "ngIf"], ["href", "javascript:void(0)", "ycnDisabled", "", 3, "class", "ngClass", "disabled", "click", 4, "ngIf"], [3, "ycnAppendToBody", "ngClass"], [3, "ngSwitch", 4, "ngFor", "ngForOf"], ["ycnTooltip", "", "href", "javascript:void(0)", "ycnDisabled", "", 3, "click", "tooltipTitle", "ngClass", "disabled"], ["ycnIcon", "", 3, "class", "name", 4, "ngIf"], [3, "textContent", 4, "ngIf"], ["ycnIcon", "", 3, "name"], [3, "textContent"], ["href", "javascript:void(0)", "ycnDisabled", "", 3, "click", "ngClass", "disabled"], [3, "ngSwitch"], ["class", "dropdown-divider", 4, "ngSwitchCase"], ["href", "javascript:void(0)", "ycnDisabled", "", 3, "class", "disabled", "click", 4, "ngSwitchCase"], [1, "dropdown-divider"], ["href", "javascript:void(0)", "ycnDisabled", "", 3, "click", "disabled"], ["ycnIcon", "", 3, "name", 4, "ngIf"], [1, "dropdown-item-text"], [3, "ngClass", "textContent"], [4, "ngIf"], [1, "help-toggler", 3, "click"]], template: function SimpleDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵtemplate(1, SimpleDropdownComponent_a_1_Template, 3, 9, "a", 2)(2, SimpleDropdownComponent_a_2_Template, 3, 8, "a", 3);
        i0.ɵɵelementStart(3, "div", 4, 0);
        i0.ɵɵtemplate(5, SimpleDropdownComponent_span_5_Template, 3, 3, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelement(6, "ycn-help-modal", null, 1);
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.tooltipText);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.tooltipText);
        i0.ɵɵadvance();
        i0.ɵɵclassMap(i0.ɵɵinterpolate1("dropdown-menu ", ctx.dropdownClass));
        i0.ɵɵproperty("ycnAppendToBody", ctx.appendToBody)("ngClass", i0.ɵɵpureFunction1(8, _c1, ctx.isOpen));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.config.list);
    } }, dependencies: [i2.AppendToBodyDirective, i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgSwitch, i3.NgSwitchCase, i4.DisabledDirective, i5.HelpModalComponent, i6.IconDirective, i7.TooltipDirective], encapsulation: 2 });
